
const digest = '18bbc99c6e5b1038d98e59b2889881921be2acd2313a2da03c1eb4a206c01dc1';
const classes = {"mainWrapper":"_mainWrapper_1gksp_1","wrapper":"_wrapper_1gksp_7"};
const css = `._mainWrapper_1gksp_1 {
  position: relative;
  height: 100%;
  overflow: hidden;
}

._wrapper_1gksp_7 {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  font-family: "Rubik", sans-serif;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  